export interface DnnColorInfo {
    color: string,
    contrastColor: string,
    lightColor: string,
    darkColor: string
};